namespace TabAurous.OMS {
    export interface ProcessApplicableDetailsRow {
        ProcessId?: number;
        CalcOnId?: number;
        CalcOn?: string;
    }

    export namespace ProcessApplicableDetailsRow {
        export const idProperty = 'ProcessId';
        export const localTextPrefix = 'OMS.ProcessApplicableDetails';
        export const deletePermission = 'Masters:ProcessMaster:Delete';
        export const insertPermission = 'Masters:ProcessMaster:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:ProcessMaster:Edit';

        export declare const enum Fields {
            ProcessId = "ProcessId",
            CalcOnId = "CalcOnId",
            CalcOn = "CalcOn"
        }
    }
}
